import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from 'react-bootstrap';

import Loader from 'dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent';

import './style.css';



const options = {
    showMargins: true
};



class DropdownMenu extends Component {

    constructor(props) {
        super(props);

        this.options = Object.assign({}, options, props.options);
    }


    // Lifecycle Methods

    render() {
        return (
            <div className={this.props.className || 'hsg-dm-root'} style={!this.options.showMargins ? { margin: 0 } : {}}>

                {Boolean(this.props.label) && <span className="hsg-dm-label-text">{this.props.label}</span>}


                {this.props.isLoading ?
                    <div style={{ padding: 10 }}><Loader /></div>

                    :

                    <div className="hsg-dm-dropdown-holder">
                        <select
                            className="hsg-dm-dropdown"
                            value={this.props.value}
                            onChange={this.props.onChange}
                            disabled={this.props.disabled}>

                            {this.renderOptions()}

                        </select>
                    </div>}

            </div>);
    }


    componentDidMount() {
        this.options = Object.assign({}, options, this.props.options);
    }


    componentWillReceiveProps(newProps) {
        this.options = Object.assign({}, options, newProps.options);
    }


    // Rendering Methods

    renderOptions() {
        return this.props.optionList.map((item, pos) =>
            <option key={pos} value={item}>{item}</option>
        );
    }

}



DropdownMenu.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string.isRequired,
    optionList: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    options: PropTypes.object
};



export default DropdownMenu